import { render, staticRenderFns } from "./AlbumActionZone.vue?vue&type=template&id=b2ef45d2&scoped=true&"
import script from "./AlbumActionZone.vue?vue&type=script&lang=js&"
export * from "./AlbumActionZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumActionZone.vue?vue&type=style&index=0&id=b2ef45d2&lang=scss&scoped=true&"
import style1 from "./AlbumActionZone.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ef45d2",
  null
  
)

export default component.exports